import { render, staticRenderFns } from "./ProductQuickEditButtons.vue?vue&type=template&id=46024c79&"
import script from "./ProductQuickEditButtons.vue?vue&type=script&lang=js&"
export * from "./ProductQuickEditButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports